import { PlatformScopeProvider } from '@/lib/platform-scope';
import { CashFlowPage, IncomeStatementPage, RevenueReportPage } from '@/modules/management';

/**
 * Os relatorios de gestao de quem administra o SaaS - as mesmas telas do
 * salao, apontadas para a empresa da propria plataforma. Cada relatorio e
 * uma pagina propria no menu, como no salao - nao uma aba.
 */
export function SaasFaturamentoPage() {
  return (
    <PlatformScopeProvider prefix="/saas/gestao">
      <RevenueReportPage />
    </PlatformScopeProvider>
  );
}

export function SaasCashFlowPage() {
  return (
    <PlatformScopeProvider prefix="/saas/gestao">
      <CashFlowPage />
    </PlatformScopeProvider>
  );
}

export function SaasIncomeStatementPage() {
  return (
    <PlatformScopeProvider prefix="/saas/gestao">
      <IncomeStatementPage />
    </PlatformScopeProvider>
  );
}
